import { styled } from "@linaria/react"
import React, { InputHTMLAttributes } from "react"
import { themeDefault } from "src/theme-revamp"

interface IOthers extends InputHTMLAttributes<HTMLTextAreaElement> {
    charLimitlabel?:string
}

function TextArea(props: React.PropsWithoutRef<IOthers>){
    const val = props.value as string 
   return (<>
    <FlexBox>
    <TextAreaBox  {...props} />
    <div className="word-count-label">{ val?.length || 0}/{props.charLimitlabel || 400}</div>
    </FlexBox>
    </>)
}

export default TextArea

const FlexBox = styled.div`
    width: 100%;
    & div {
        text-align: end;
        color: #C9C9C9;
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 0.18px;
    }
`

const TextAreaBox = styled.textarea`
    box-sizing: border-box;
    resize: none;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    height:142px;
    width: 100%;
    box-shadow: none;
    outline: none;
`